import { FC } from 'react';
import styles from './ImgFullLabel.module.scss';

interface IImgFullLabel {
  extraClassName?: string;
}

const ImgFullLabel: FC<IImgFullLabel> = ({ extraClassName }) => {
  return <div className={extraClassName ? `${styles.imgFullLabel} ${styles[`${extraClassName}`]}` : `${styles.imgFullLabel}`}>Полная версия</div>;
};
export default ImgFullLabel;
